<template>
     <b-modal id="editQuestionnaireModal" hide-backdrop centered :no-close-on-esc="true"
          v-bind:title="questionnaireSettingsTitle" ok-title="Update" @ok="updateSettings" @shown="updateQuestionnaireSettings(tenant)"
          :ok-disabled="okButtonDisabledQuestionnaire" @hidden="editQuestionnaireModal" @cancel="editQuestionnaireModal">
          <b-form ref="form">
            <b-form-group>
              <label class="checkbox-container">
                Activate Questionnaire Template
                <input type="checkbox" :value="hasQuestionnarieTemplete" id="hasQuestionnarieTempletes"
                  v-model="hasQuestionnarieTemplete" :disabled="hasQuestionnarieTemplete"
                  @input="markAsChanged('hasQuestionnarieTemplete')" />
                <span class="checkmark"></span>
              </label>
            </b-form-group>
            <b-form-group>
              <label class="checkbox-container">
                Enable CSV Download
                <input type="checkbox" :value="editCSVDownload" id="editCSVDownload" v-model="editCSVDownload"
                  @input="markAsChanged('enableCSVDownload')" />
                <span class="checkmark"></span>
              </label>
            </b-form-group>
            <b-form-group>
              <label class="checkbox-container">
                Punch-In data available
                <input type="checkbox" :value="punchInData" id="punchInData" v-model="punchInData"
                  @input="markAsChanged('punchInDataAvailable')" />
                <span class="checkmark"></span>
              </label>
            </b-form-group>
            <b-form-group>
              <label class="checkbox-container">
                Employee Id is not Unique (Uniqueness is based on EmployeeId and
                Name)
                <input type="checkbox" :value="employeeIdNotUnique" id="employeeIdNotUnique" v-model="employeeIdNotUnique"
                  @input="markAsChanged('employeeIdNotUnique')" />
                <span class="checkmark"></span>
              </label>
            </b-form-group>
            <b-form-group>
              <label class="checkbox-container">
                Enable Tenant Scheduling
                <input type="checkbox" :value="enableSchedule" id="enableSchedule" v-model="enableSchedule"
                  @input="markAsChanged('enableSchedule')" />
                <span class="checkmark"></span>
              </label>
            </b-form-group>
            <b-form-group>
              <label class="checkbox-container">
                Add address fields to Screening Questionnaire
                <input type="checkbox" :value="hasQuestionnarieAddress" id="hasQuestionnarieAddress"
                  v-model="hasQuestionnarieAddress" @input="markAsChanged('hasQuestionnarieAddress')" />
                <span class="checkmark"></span>
              </label>
            </b-form-group>
            <b-form-group>
              <label class="checkbox-container">
                Hide All Facilities
                <input type="checkbox" :value="hideAllFacilities" id="hideAllFacilities" v-model="hideAllFacilities"
                  @input="markAsChanged('hideAllFacilities')" />
                <span class="checkmark"></span>
              </label>
            </b-form-group>
            <b-form-group>
              <label class="checkbox-container">
                Enable Timer Entrance Activity
                <input type="checkbox" :value="enableTimerInEntranceActivity" id="enableTimerInEntranceActivity"
                  v-model="enableTimerInEntranceActivity" @input="markAsChanged('enableTimerInEntranceActivity')" />
                <span class="checkmark"></span>
              </label>
            </b-form-group>
            <b-form-group>
              <label class="custom-form-label">Entrance Activity Refresh Rate In Seconds</label>
              <b-form-input id="refreshRateInSeconds" type="text"
                @input="validateNumericInputQuestionnaire(); markAsChanged('entranceActivityRefreshRateInSeconds')"
                v-model="refreshRateInSeconds"
                :class="refreshRateInSeconds !== null && !isNumeric(refreshRateInSeconds) ? 'in-valid' : 'valid'"></b-form-input>
              <p v-if="refreshRateInSeconds !== null && !isNumeric(refreshRateInSeconds)" style="color: red">Please enter
                a valid numeric value.</p>
            </b-form-group>


            <b-form-group>
              <label class="custom-form-label">Low Temperature Cutoff</label>
              <b-form-input type="text"
                @input="validateNumericInputQuestionnaire(); markAsChanged('lowTemperatureCutoff')" id="temperatureCutoff"
                v-model="temperatureCutoff"
                :class="temperatureCutoff !== null && !isNumeric(temperatureCutoff) ? 'in-valid' : 'valid'"></b-form-input>
              <p v-if="temperatureCutoff !== null && !isNumeric(temperatureCutoff)" style="color: red">Please enter a
                valid numeric value.</p>
            </b-form-group>
            <div class="permissionContentWrapper">
              <div class="contentData row m-0 align-items-center col-12 p-0" v-for="(item, index) in items"
                v-bind:key="item">
                <div class="col">
                  {{
                    permissions.find((p) => p.value == item)
                    ? permissions.find((p) => p.value == item).text
                    : ""
                  }}
                </div>
                <div class="col actionHeading text-center">
                  <img v-on:click="removePermission(index)" src="../../assets/images/remove.svg" width="16" />
                </div>
              </div>
            </div>
            <p v-if="questionnaireConfigurationErrorMessage !== null || questionnaireConfigurationErrorMessage !== ''"
              style="color: red">{{
                questionnaireConfigurationErrorMessage }}</p>

          </b-form>
        </b-modal>
</template>
<script>
  import Vue from "vue";

export default{
    data(){
        return{
            okButtonDisabledQuestionnaire: false,
             hasQuestionnarieTemplete: false,
            hasQuestionnarieTempleteExists: false,
            changedWebSettingsControls: {},
            questionnaireConfigurationErrorMessage:"",
            questionnaireSettingsTitle:"",
             doNotStoreImages: false,
             hasQuestionnarieAddress: false,
             enableSchedule: false,
             employeeIdNotUnique: false,
             editCSVDownload: false,
             refreshRateInSeconds: 30,
             preventPTTSS: false,
             punchInData: false,
             temperatureCutoff: 0,
             useTenantSpecificRoles: false,
             patientNameFormatSelectedOption: "FNF",
             vm_maxViewMode: "",
             vm_popupInterval: 60,
             vm_popupCheckInterval: 15,
             hideAllFacilities: false,
             enableTimerInEntranceActivity: false,
             disableNoiseSuppression: false,
             disableVirtualNursingChime: false,
             endCallTimeout: 40,
             items: [],
        }
    },
    props:['tenant','tenants'],
    methods:{
        async updateQuestionnaireSettings(tenant) {
        this.tenants;
        this.lastTenant = tenant.name;
        this.questionnaireSettingsTitle = "Smart Entry Settings - " + tenant.name;
        this.doNotStoreImages = tenant.isPrivacyEnabled
            ? tenant.isPrivacyEnabled
            : false;
        this.hasQuestionnarieTemplete =
            tenant &&
            tenant.webSettings &&
            tenant.webSettings.hasQuestionnarieTemplete
                ? tenant.webSettings.hasQuestionnarieTemplete
                : false;
        this.hasQuestionnarieTempleteExists =
            tenant &&
            tenant.webSettings &&
            tenant.webSettings.hasQuestionnarieTemplete
                ? tenant.webSettings.hasQuestionnarieTemplete
                : false;
        this.hasQuestionnarieAddress =
            tenant &&
            tenant.webSettings &&
            tenant.webSettings.hasQuestionnarieAddress
                ? tenant.webSettings.hasQuestionnarieAddress
                : false;
        this.enableSchedule =
            tenant && tenant.webSettings && tenant.webSettings.enableSchedule
                ? tenant.webSettings.enableSchedule
                : false;
        this.employeeIdNotUnique =
            tenant && tenant.webSettings && tenant.webSettings.employeeIdNotUnique
                ? tenant.webSettings.employeeIdNotUnique
                : false;
        this.editCSVDownload =
            tenant && tenant.webSettings && tenant.webSettings.enableCSVDownload
                ? tenant.webSettings.enableCSVDownload
                : false;
        this.refreshRateInSeconds =
            tenant &&
            tenant.webSettings &&
            tenant.webSettings.entranceActivityRefreshRateInSeconds
                ? tenant.webSettings.entranceActivityRefreshRateInSeconds
                : 0;
  
  
        this.preventPTTSS = tenant &&
        tenant.webSettings &&
        tenant.webSettings.preventPTTSS
            ? tenant.webSettings.preventPTTSS
            : false;
        this.punchInData =
            tenant && tenant.webSettings && tenant.webSettings.punchInDataAvailable
                ? tenant.webSettings.punchInDataAvailable
                : false;
        this.temperatureCutoff =
            tenant && tenant.webSettings && tenant.webSettings.lowTemperatureCutoff ? tenant.webSettings.lowTemperatureCutoff : 0;
        this.useTenantSpecificRoles =
            tenant &&
            tenant.webSettings &&
            tenant.webSettings.useTenantSpecificRoles
                ? tenant.webSettings.useTenantSpecificRoles
                : false;
        //new fields added are from here 2507 tickets--starts here 
        this.patientNameFormatSelectedOption = tenant && tenant.webSettings && tenant.webSettings.patientNameFormat ? tenant.webSettings.patientNameFormat : "FNF";
        this.vm_maxViewMode = tenant && tenant.webSettings && tenant.webSettings.vm_maxViewMode ? tenant.webSettings.vm_maxViewMode
            : '1col';
  
        this.vm_popupInterval = tenant && tenant.webSettings && tenant.webSettings.vm_popupInterval ? tenant.webSettings.vm_popupInterval / 60000
            : 60;
  
        this.vm_popupCheckInterval = tenant && tenant.webSettings && tenant.webSettings.vm_popupCheckInterval ? tenant.webSettings.vm_popupCheckInterval / 60000
            : 15;
  
        this.hideAllFacilities = tenant && tenant.webSettings && tenant.webSettings.hideAllFacilities ? tenant.webSettings.hideAllFacilities
            : false;
  
        this.enableTimerInEntranceActivity = tenant && tenant.webSettings && tenant.webSettings.enableTimerInEntranceActivity ? tenant.webSettings.enableTimerInEntranceActivity
            : false;
  
        this.disableNoiseSuppression = tenant && tenant.webSettings && tenant.webSettings.disableNoiseSuppression ? tenant.webSettings.disableNoiseSuppression
            : false;
  
        this.disableVirtualNursingChime = tenant && tenant.webSettings && tenant.webSettings.disableVirtualNursingChime ? tenant.webSettings.disableVirtualNursingChime
            : false;
  
        this.endCallTimeout = tenant && tenant.webSettings && tenant.webSettings.endCallTimeout ? tenant.webSettings.endCallTimeout / 1000
            : 40;
      },
        updateSelectedOtherWebSettingsChanges() {
        let settingsObject = {};
        if (this.changedWebSettingsControls.hasOwnProperty('hasQuestionnarieTemplete')) {
          settingsObject['hasQuestionnarieTemplete'] = this.hasQuestionnarieTemplete;
        }
        if (this.changedWebSettingsControls.hasOwnProperty('entranceActivityRefreshRateInSeconds')) {
          settingsObject['entranceActivityRefreshRateInSeconds'] = this.refreshRateInSeconds;
        }
  
        if (this.changedWebSettingsControls.hasOwnProperty('enableCSVDownload')) {
          settingsObject['enableCSVDownload'] = this.editCSVDownload;
        }
  
        if (this.changedWebSettingsControls.hasOwnProperty('punchInDataAvailable')) {
          settingsObject['punchInDataAvailable'] = this.punchInData;
        }
  
        if (this.changedWebSettingsControls.hasOwnProperty('lowTemperatureCutoff')) {
          settingsObject['lowTemperatureCutoff'] = this.temperatureCutoff;
        }
  
        if (this.changedWebSettingsControls.hasOwnProperty('employeeIdNotUnique')) {
          settingsObject['employeeIdNotUnique'] = this.employeeIdNotUnique;
        }
  
        if (this.changedWebSettingsControls.hasOwnProperty('enableSchedule')) {
          settingsObject['enableSchedule'] = this.enableSchedule;
        }
  
        if (this.changedWebSettingsControls.hasOwnProperty('useTenantSpecificRoles')) {
          settingsObject['useTenantSpecificRoles'] = this.useTenantSpecificRoles;
        }
  
        if (this.changedWebSettingsControls.hasOwnProperty('hasQuestionnarieAddress')) {
          settingsObject['hasQuestionnarieAddress'] = this.hasQuestionnarieAddress;
        }
  
        if (this.changedWebSettingsControls.hasOwnProperty('patientNameFormat')) {
          settingsObject['patientNameFormat'] = this.patientNameFormatSelectedOption;
        }
  
        if (this.changedWebSettingsControls.hasOwnProperty('vm_maxViewMode')) {
          settingsObject['vm_maxViewMode'] = this.vm_maxViewMode;
        }
        if (this.changedWebSettingsControls.hasOwnProperty('vm_popupInterval')) {
          settingsObject['vm_popupInterval'] = this.vm_popupInterval * 60000;
        }
  
        if (this.changedWebSettingsControls.hasOwnProperty('vm_popupCheckInterval')) {
          settingsObject['vm_popupCheckInterval'] = this.vm_popupCheckInterval * 60000;
        }
  
        if (this.changedWebSettingsControls.hasOwnProperty('hideAllFacilities')) {
          settingsObject['hideAllFacilities'] = this.hideAllFacilities;
        }
  
        if (this.changedWebSettingsControls.hasOwnProperty('enableTimerInEntranceActivity')) {
          settingsObject['enableTimerInEntranceActivity'] = this.enableTimerInEntranceActivity;
        }
  
        if (this.changedWebSettingsControls.hasOwnProperty('disableNoiseSuppression')) {
          settingsObject['disableNoiseSuppression'] = this.disableNoiseSuppression;
        }
  
        if (this.changedWebSettingsControls.hasOwnProperty('disableVirtualNursingChime')) {
          settingsObject['disableVirtualNursingChime'] = this.disableVirtualNursingChime;
        }
  
        if (this.changedWebSettingsControls.hasOwnProperty('endCallTimeout')) {
          settingsObject['endCallTimeout'] = this.endCallTimeout * 1000;
        }
        if (this.customHelpmessage != '') {
          settingsObject['customHelpMessage'] = this.customHelpmessage;
        }
        if (this.changedWebSettingsControls.hasOwnProperty('preventPTTSS')) {
          settingsObject['preventPTTSS'] = this.preventPTTSS;
        }
        return settingsObject;
      }
      ,
      markAsChanged(controlName) {
        this.$set(this.changedWebSettingsControls, controlName, true);
      },
        editQuestionnaireModal() {
        this.questionnaireConfigurationErrorMessage = ''
        this.$bvModal.hide("editQuestionnaireModal");
      },
    isNumeric(value) {
      return /^[+-]?\d+(\.\d+)?$/.test(value);
    },
        isConditionSatisfiedQuestionnaire() {
        if (this.isNumeric(this.refreshRateInSeconds) && this.isNumeric(this.temperatureCutoff)) {
          this.okButtonDisabledQuestionnaire = false;
          this.questionnaireConfigurationErrorMessage = ""
        } else {
          this.questionnaireConfigurationErrorMessage = "Some fields are invalid!, Please do update them."
          this.okButtonDisabledQuestionnaire = true;
        }
      },
        async updateSettings(command, args, when) {
        if (
            this.hasQuestionnarieTempleteExists == false &&
            this.hasQuestionnarieTemplete == true
        ) {
          this.createQuestionnaire(this.lastTenant);
        }
        if (this.hasQuestionnarieAddress == true) {
          this.createQuestionnaireAddress(this.lastTenant);
        }
        if (this.enableSchedule == true) {
          this.createTenantScheduling(this.lastTenant);
        }
  
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        var url =
            config.TENET_SERVICE + `/tenants/${this.lastTenant}/updateWebSettings`;
  
        var tenants_settings_request = new Request(url, {
          method: "PATCH",
          mode: "cors",
          withCredentials: true,
          credentials: "include",
          cache: "default",
          body: JSON.stringify({
            doNotStoreImages: this.doNotStoreImages,
            otherWebSettings: this.updateSelectedOtherWebSettingsChanges(),
          }),
          headers: {
            Authorization: "Bearer " + id_token,
            "Content-Type": "application/json",
          },
        });
        try {
          var tenantSettingsResponse = await fetch(tenants_settings_request);
          if (tenantSettingsResponse.status === 403) {
            this.errorMessage =
                "Uh oh... You don't have the permission required to access this resource";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
  
            return;
          }
          if (tenantSettingsResponse.status == 401) {
            this.errorMessage =
                "Your session has expired please login again to continue";
            Vue.$toast.open({message: this.errorMessage, type: "error"});
            return;
          }
          if (tenantSettingsResponse.status == 503) {
            return this.updateSettings(command, args, when);
          }
          if (tenantSettingsResponse.status != 200) {
            (this.errorMessage = "Error occurred to "),
                command.command,
                " :",
                tenantSettingsResponse.status;
  
            this.commandError = "Failed to update " + this.modalUpdateText;
            Vue.$toast.open({message: this.commandError, type: "error"});
          } else {
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "hasQuestionnarieTemplete"
                ] = this.hasQuestionnarieTemplete;
            this.tenants.find((x) => x.name === this.lastTenant)[
                "isPrivacyEnabled"
                ] = this.doNotStoreImages;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "hasQuestionnarieAddress"
                ] = this.hasQuestionnarieAddress;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "enableSchedule"
                ] = this.enableSchedule;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "employeeIdNotUnique"
                ] = this.employeeIdNotUnique;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "enableCSVDownload"
                ] = this.editCSVDownload;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "entranceActivityRefreshRateInSeconds"
                ] = this.refreshRateInSeconds;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "punchInDataAvailable"
                ] = this.punchInData;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "lowTemperatureCutoff"
                ] = this.temperatureCutoff;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "useTenantSpecificRoles"
                ] = this.useTenantSpecificRoles;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "preventPTTSS" 
                ] = this.preventPTTSS;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "customHelpMessage"
                ] = this.customHelpmessage;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "disableNoiseSuppression"
                ] = this.disableNoiseSuppression;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "disableVirtualNursingChime"
                ] = this.disableVirtualNursingChime;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "patientNameFormat"
                ] = this.patientNameFormatSelectedOption;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "vm_popupInterval"
                ] = this.vm_popupInterval * 60000;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "vm_popupCheckInterval"
                ] = this.vm_popupCheckInterval * 60000;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "hideAllFacilities"
                ] = this.hideAllFacilities;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "enableTimerInEntranceActivity"] =
                this.enableTimerInEntranceActivity;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "endCallTimeout"] =
                this.endCallTimeout * 1000;
            this.tenants.find((x) => x.name === this.lastTenant)["webSettings"][
                "vm_maxViewMode"] =
                this.vm_maxViewMode;
            var tenantsBody = await tenantSettingsResponse.json();
            this.commandError = "";
            this.changedWebSettingsControls = {};
            Vue.$toast.open({
              message: "Successfully Updated " + this.modalUpdateText,
              type: "success",
            });
          }
        } catch (tex) {
          this.commandError = "Failed! due to an error.";
          Vue.$toast.open({message: this.commandError, type: "error"});
        }
        //  this.fetchData();
      },
      
    validateNumericInputQuestionnaire() {
      if (!this.isNumeric(this.numericValue)) {
        this.numericValue = null;
        this.isConditionSatisfiedQuestionnaire()
      }
    },
    
    async createQuestionnaireAddress(tenant) {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
          config.COVID_SURVEY + `/createQuestionnaireAddress?tenants=${tenant}`;
      var tenantScheduling = new Request(url, {
        method: "POST",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var questionnaireAddressResponse = await fetch(questionnaireAddress);

        if (questionnaireAddressResponse.status === 403) {
          this.errorMessage =
              "Uh oh... You don't have the permission required to access this resource";
          Vue.$toast.open({message: this.errorMessage, type: "error"});
          return;
        }
        if (questionnaireAddressResponse.status == 401) {
          this.errorMessage =
              "Your session has expired please login again to continue";
          Vue.$toast.open({message: this.errorMessage, type: "error"});
          return;
        }
        if (questionnaireAddressResponse.status == 503) {
          return this.createQuestionnaireAddress(tenant);
        }
        if (questionnaireAddressResponse.status != 200) {
          this.commandError = "Failed to send email for onboarding";
          Vue.$toast.open({message: this.commandError, type: "error"});
        } else {
          var sendTempleteBody = await questionnaireAddressResponse.json();
          Vue.$toast.open({
            message: "Created Questionnaire Address",
            type: "info",
            duration: 3000,
            position: "bottom",
          });
        }
      } catch (tex) {
        this.commandError =
            "Failed to " + command.command + " due to an error.";
        Vue.$toast.open({message: this.commandError, type: "error"});
      }
    },
    async createQuestionnaire(tenant) {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
          config.COVID_SURVEY + `/createQuestionnaireTemplete?tenants=${tenant}`;
      var sendQuestionnaireTemplete = new Request(url, {
        method: "POST",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var sendQuestionnaireTempleteResponse = await fetch(
            sendQuestionnaireTemplete
        );
        if (sendQuestionnaireTempleteResponse.status === 403) {
          this.errorMessage =
              "Uh oh... You don't have the permission required to access this resource";
          Vue.$toast.open({message: this.errorMessage, type: "error"});
          return;
        }
        if (sendQuestionnaireTempleteResponse.status == 401) {
          this.errorMessage =
              "Your session has expired please login again to continue";
          Vue.$toast.open({message: this.errorMessage, type: "error"});
          return;
        }
        if (sendQuestionnaireTempleteResponse.status == 500) {
          this.commandError = "Questionnarie Templete already exist";
          Vue.$toast.open({message: this.commandError, type: "error"});
          return;
        }
        if (sendQuestionnaireTempleteResponse.status == 503) {
          return this.createQuestionnaire(tenant);
        }
        if (sendQuestionnaireTempleteResponse.status != 200) {
          this.commandError = "Failed to create questionnaries";
          Vue.$toast.open({message: this.commandError, type: "error"});
        } else {
          var sendTempleteBody = await sendQuestionnaireTempleteResponse.json();
          Vue.$toast.open({
            message: "Questionnaire Templete created",
            type: "info",
            duration: 3000,
            position: "bottom",
          });
        }
      } catch (tex) {
        this.commandError =
            "Failed to " + command.command + " due to an error.";
        Vue.$toast.open({message: this.commandError, type: "error"});
      }
    },
    async createTenantScheduling(tenant) {
      const claims = await this.$auth.getIdTokenClaims();
      const id_token = claims.__raw;
      var url =
          config.COVID_SURVEY + `/createTenantScheduling?tenants=${tenant}`;
      var tenantScheduling = new Request(url, {
        method: "POST",
        mode: "cors",
        withCredentials: true,
        credentials: "include",
        cache: "default",
        headers: {
          Authorization: "Bearer " + id_token,
          "Content-Type": "application/json",
        },
      });
      try {
        var tenantSchedulingResponse = await fetch(tenantScheduling);
        if (tenantSchedulingResponse.status === 403) {
          this.errorMessage =
              "Uh oh... You don't have the permission required to access this resource";
          Vue.$toast.open({message: this.errorMessage, type: "error"});
          return;
        }
        if (tenantSchedulingResponse.status == 401) {
          this.errorMessage =
              "Your session has expired please login again to continue";
          Vue.$toast.open({message: this.errorMessage, type: "error"});
          return;
        }
        if (tenantSchedulingResponse.status == 503) {
          return this.createTenantScheduling(tenant);
        }
        if (tenantSchedulingResponse.status != 200) {
          this.commandError = "Failed to send email for onboarding";
          Vue.$toast.open({message: this.commandError, type: "error"});
        } else {
          var sendTempleteBody = await tenantSchedulingResponse.json();
          Vue.$toast.open({
            message: "Tenant Scheduling created",
            type: "info",
            duration: 3000,
            position: "bottom",
          });
        }
      } catch (tex) {
        this.commandError =
            "Failed to " + command.command + " due to an error.";
        Vue.$toast.open({message: this.commandError, type: "error"});
      }
    },
    }
}

</script>
<style scoped lang="scss">
  @import "../../style.scss";

    .btn-secondary {
      border-color: #1dd8f6 !important;
    }
  
    .checkbox-container {
      color: #6a6a6a;
      font-family: GTWalsheimPro-Regular;
    }
  
    .custom-form-label {
      color: #3288D2;
      font-family: GTWalsheimPro-Regular !important;
      font-size: 16px;
      font-weight: 400;
    }
    .in-valid {
       border-color: #dc1414 !important;
    }
    .valid {
       border-color: 1px solid #7a8991 !important;
    }
</style>